/**
 *
 * Asynchronously loads the component for DataConfiguration
 *
 */

import { lazyLoad } from 'utils/loadable';

export const DataConfiguration = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.DataConfiguration,
);
